import { useEffect, useState } from 'react';

/** Load something async once per dependency change; null until it arrives (or if it fails). `done`
 *  tells a load that came back empty from one still on its way. */
export function useLoaded<T>(load: () => Promise<T> | null, deps: unknown[]): { value: T | null; error: string | null; done: boolean } {
  const [state, setState] = useState<{ value: T | null; error: string | null; done: boolean }>({ value: null, error: null, done: false });
  useEffect(() => {
    let live = true;
    const p = load();
    setState({ value: null, error: null, done: !p });
    p?.then(
      (value) => live && setState({ value, error: null, done: true }),
      (err: unknown) => live && setState({ value: null, error: err instanceof Error ? err.message : String(err), done: true }),
    );
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
}
